import { useScrollReveal } from '@/hooks/useScrollReveal';

const CTA_URL = 'https://www.linkedin.com/in/vinoth-trevor-skanthavarathan-01b6ba141/';

const LegalClose = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="legal-close-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-close-h2">
          Start with one workflow
        </h2>

        <p className="legal-body mt-8" data-testid="legal-close-body">
          Tell us the recurring task that takes too long, and which matter type it happens in. If it is not a fit, we will say so.
        </p>

        <div className="mt-10">
          <a
            href={CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="legal-close-cta"
            className="cta-button"
          >
            Start with one workflow
          </a>
        </div>

        <p className="legal-tagline mt-8" data-testid="legal-close-tagline">
          Before it costs you.
        </p>
      </div>
    </section>
  );
};

export default LegalClose;
